import { holdsCustomerRole } from '~/utils/holdsCustomerRole'
import type { UserRole } from '~/enums'

export function resolveRoleHomeDestination(roles: readonly UserRole[]): string {
  return holdsCustomerRole(roles) ? '/' : '/dashboard'
}
